import React, { useState, useEffect } from "react";
import { Field, useFormikContext } from "formik";
import Select from "react-select";
import {
  Grid,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  Avatar,
  TextField
} from "@mui/material";
import dayjs from "dayjs";

const BaptismsStep =  React.memo(({ metadata }) => {
  const { values, errors, touched, setFieldValue } = useFormikContext();

  const [pastores, setPastores] = useState([]);
  const [iglesias, setIglesias] = useState([]);
  const [useApiPastores, setUseApiPastores] = useState(false);
  const [useApiIglesias, setUseApiIglesias] = useState(false);

  // Cargar datos de pastores e iglesias desde metadata al iniciar
  useEffect(() => {
    setPastores(
      metadata?.pastors.map((pastor) => ({
        value: pastor.id,
        label: pastor.name
      })) || []
    );

    const mappedIglesias =
    metadata?.churches.map((iglesia) => ({
      value: iglesia.id,
      label: iglesia.name,
    })) || [];

  setIglesias(mappedIglesias);

  // Si solo hay una iglesia, seleccionarla automáticamente
  /*
  if (mappedIglesias.length === 1) {
    setFieldValue(
      `bautismos.bautismo_aguas.church_id`,
      mappedIglesias[0].value
    );
    setFieldValue(
      `bautismos.bautismo_espiritu_santo.church_id`,
      mappedIglesias[0].value
    );
  }*/
  }, [metadata, setFieldValue]);

  // Actualizar fecha al habilitar el checkbox
  const handleCheckboxChange = (tipoBautismo, enabled) => {
    setFieldValue(`bautismos.${tipoBautismo}.enabled`, enabled);
    if (enabled) {
      setFieldValue(
        `bautismos.${tipoBautismo}.fecha`,
        dayjs().format("YYYY-MM-DD")
      );
    } else {
      setFieldValue(`bautismos.${tipoBautismo}`, {
        ...values.bautismos[tipoBautismo],
        enabled: false,
        fecha: "",
        pastor_id: 0,
        church_id: 0,
      });
    }
  };

  // Renderizar campos de formulario dinámico por tipo de bautismo
  const renderBaptismFields = (tipoBautismo) => (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>

          <Field name={`bautismos.${tipoBautismo}.fecha`}>
            {({ field }) => {
              const error =
                errors?.bautismos?.[tipoBautismo]?.fecha &&
                touched?.bautismos?.[tipoBautismo]?.fecha;
              return (
                <TextField
                  {...field}
                  label="Fecha del Bautismo"
                  type="date"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  error={Boolean(error)}
                  helperText={
                    error
                      ? errors.bautismos[tipoBautismo]?.fecha
                      : ""
                  }
                />
              );
            }}
          </Field>

        </Grid>


<Grid item xs={12} sm={6}>
  <Typography>Seleccionar Pastor</Typography>
  <Select
    options={pastores}
    onChange={(option) =>
      setFieldValue(
        `bautismos.${tipoBautismo}.pastor_id`,
        option?.value || ""
      )
    }
    placeholder="Seleccionar Pastor"
    isClearable // Permite limpiar el valor seleccionado
  />
  {errors?.bautismos?.[tipoBautismo]?.pastor_id &&
    touched?.bautismos?.[tipoBautismo]?.pastor_id && (
      <Typography color="error">
        {errors.bautismos[tipoBautismo].pastor_id}
      </Typography>
    )}
</Grid>

{/* Selector de Iglesia */}
<Grid item xs={12} sm={6}>
  <Typography>Seleccionar Iglesia</Typography>
  <Select
    options={iglesias}
    value={
      iglesias.find(
        (iglesia) =>
          iglesia.value === values?.bautismos?.[tipoBautismo]?.church_id
      ) || null
    }
    onChange={(option) =>
      setFieldValue(
        `bautismos.${tipoBautismo}.church_id`,
        option?.value || ""
      )
    }
    placeholder="Seleccionar Iglesia"
    isClearable // Permite limpiar el valor seleccionado
  />
  {errors?.bautismos?.[tipoBautismo]?.church_id &&
    touched?.bautismos?.[tipoBautismo]?.church_id && (
      <Typography color="error">
        {errors.bautismos[tipoBautismo].church_id}
      </Typography>
    )}
</Grid>

      </Grid>
    </>
  );

  return (
    <Grid container spacing={4}>
      {/* Bautismo en Aguas */}
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.bautismos?.bautismo_aguas?.enabled || false}
              onChange={(e) =>
                handleCheckboxChange("bautismo_aguas", e.target.checked)
              }
            />
          }
          label="Bautismo en Aguas"
        />
        {values.bautismos?.bautismo_aguas?.enabled &&
          renderBaptismFields("bautismo_aguas")}
      </Grid>

      {/* Bautismo en Espíritu Santo */}
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                values.bautismos?.bautismo_espiritu_santo?.enabled || false
              }
              onChange={(e) =>
                handleCheckboxChange(
                  "bautismo_espiritu_santo",
                  e.target.checked
                )
              }
            />
          }
          label="Bautismo en Espíritu Santo"
        />
        {values.bautismos?.bautismo_espiritu_santo?.enabled &&
          renderBaptismFields("bautismo_espiritu_santo")}
      </Grid>
    </Grid>
  );
});

export default BaptismsStep;
